<template>
    <div class="table-picto" @click="updateValue()" :class="{'active': isChecked}">
        <div class="picto">
            <div :class="pictoClass"></div>
        </div>
        <div class="picto-name">{{ label }}</div>
    </div>
</template>
<script>
    export default {
      name: 'Item',
      props: {
        pictoClass: String,
        label: String,
        value: Boolean
      },
      methods: {
        updateValue: function () {
          this.isChecked = !this.isChecked
          this.$emit('input', this.isChecked);
        }
      },
      watch: {
        value: function(newVal) { // watch it
          this.isChecked = newVal
        }
      },

      data(){
        return {
          isChecked: this.value
        }
      },
    }
</script>
<style lang="scss" scoped>
    @import "@/assets/styles/components/select_filter.sass"
</style>